import { render } from "./AddCreditBox.vue?vue&type=template&id=1054af8a"
import script from "./AddCreditBox.vue?vue&type=script&lang=js"
export * from "./AddCreditBox.vue?vue&type=script&lang=js"

import "./AddCreditBox.vue?vue&type=style&index=0&id=1054af8a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__